import api from './api';

const API_PATH = '/api/settings';

export const getSettings = async () => {
    try {
        const response = await api.get(API_PATH);
        return response.data || response;
    } catch (error) {
        throw error;
    }
};



